import { QuestionResponse_CandidateTestResponsesFragment } from "~/__generated__/graphql"
import { TestQuestionResponse } from "./TestQuestionResponse"

interface TestQuestionResponsesListProps {
  data: QuestionResponse_CandidateTestResponsesFragment[]
  viewPath: (test: QuestionResponse_CandidateTestResponsesFragment) => string
  canEdit?: boolean
  onlyAnswered?: boolean
}

export const TestQuestionResponsesList = ({
  data,
  viewPath,
  canEdit = true,
  onlyAnswered = false,
}: TestQuestionResponsesListProps) => {
  if (onlyAnswered) {
    data = data.filter((response) => response.state === "completed")
  }

  return (
    <>
      <div className="flex flex-col gap-4 w-full">
        {data.length === 0 && (
          <div className="p-6 text-center text-gray-333">No responses yet.</div>
        )}
        {data.map((response) => (
          <TestQuestionResponse
            key={response.id}
            response={response}
            viewPath={viewPath}
            canEdit={canEdit}
          />
        ))}
      </div>
    </>
  )
}
